<template>
  <div id="character-move-wrap">
    <div class="character-move-heading checkbox-wrap">
      <input
        type="checkbox"
        name="have-move"
        id="have-move"
        class="checkbox"
        v-if="move.have !== null"
        v-model="move.have"
      />
      <h4 @click="showMoveBody = !showMoveBody" class="post-checkbox">{{ move.title }}</h4>
    </div>
    <div
      class="move-body"
      ref="moveBody"
      :style="move.have !== null ? 'margin-left: 1.5em;' : ''"
      v-html="move.html"
      v-show="showMoveBody"
    ></div>
  </div>
</template>

<script>
export default {
  name: "CharacterMove",
  props: ["move"],
  data() {
    return {
      showMoveBody: false,
      have: null,
      extras: []
    };
  },
  async mounted() {
    if (this.move.extra) {
      let temp = await this.$refs;
      // Get each of the moves that have extra properties and set them accordingly
      this.move.extra.forEach((extra, index) => {
        let el = temp["moveBody"].querySelector(`#${extra.marker}`);
        if (extra.type === "checkbox") {
          if (extra.value) {
            el.setAttribute("checked", true);
          }
          el.addEventListener("click", () => {
            // update the move and then push it to the store
            this.move.extra[index].value = el.checked;
          });
        } else if (extra.type === "text") {
          el.value = this.move.extra[index].value;
          el.addEventListener("keyup", () => {
            this.move.extra[index].value = el.value;
          });
        }
      });
    }
    // Then save that new data into the 'character' to be pulled up later

    this.have = this.move.have;
  },
  watch: {
    move: {
      handler: function(val) {
        this.$store.commit("updateCharacterMoves", val);
      },
      deep: true
    }
  }
};
</script>

<style lang="css">
#character-move-wrap {
  margin-top: 0.5em;
}

.character-move-heading {
  display: flex;
}

.character-move-heading > h4 {
  margin-top: 0;
  margin-bottom: 0.2em;
  border-bottom: 1px solid black;
}

.character-move-heading > #have-move {
  width: 1em;
  height: 1em;
  background: white;
}

#character-move-wrap > .move-body > * {
  /* margin-left: 2em; */
  margin-top: 0.5em;
  text-align: left;
  font-size: 14px;
}

.move-property {
  display: flex;
}

#character-move-wrap .moves-text-input {
  padding: 2px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-size: 14px;
  border: none;
  border-radius: 0;
  border-bottom: solid 1px black;
}
</style>